import { LocalNotifications } from "@capacitor/local-notifications";
import logEvent from "analytics";

export function registerLocalNotificationActionListener() {
  LocalNotifications.addListener("localNotificationActionPerformed", (notification) => {
    const extraData = notification.notification.extra || {};
    logEvent("launched_from_local_notif", {
      notificationId: notification.notification.id,
      ...extraData,
    });
  });
}
